import ResistancePanel from "../ResistancePanel/ResistancePanel";
import { CharacterData } from "../../../../utils/game/character/CharacterData";
import StatBoard from "../../../../utils/game/mechanics/StatBoard";
import FlexColumn from "../../../../common/components/layout/Flexbox/FlexColumn";
import FlexRow from "../../../../common/components/layout/Flexbox/FlexRow";
import BorderedPanel from "../../../../common/components/display/BorderedPanel/BorderedPanel";
import {ReactElement} from "react";

type Props = {
    alignment?: "start" | "center" | "end";
    characterData: CharacterData;
    statBoard: StatBoard;
    onResistanceTitleClick?: (resistanceName: string) => void;
};

export default function ResistancesContainer({
    alignment,
    characterData,
    statBoard,
    onResistanceTitleClick
}: Props): ReactElement {
    return (
        <>
            <FlexRow alignment="center">
                <div
                    style={{
                        fontSize: "80%",
                        fontWeight: "bold",
                        marginTop: "1px",
                        padding: "4px 40px",
                        border: "1px solid black",
                        borderRadius: "12px",
                        userSelect: "none",
                        backgroundColor: "#b1bbbd"
                    }}
                >
                    Resistances
                </div>
            </FlexRow>
            <FlexRow alignment={alignment} wrap={true} style={{marginTop: 4}}>
                <ResistancePanel statBoard={statBoard} statKey="BLURES" onResistanceTitleClick={() => {onResistanceTitleClick?.("Blunt")}} />
                <ResistancePanel statBoard={statBoard} statKey="COLRES" onResistanceTitleClick={() => {onResistanceTitleClick?.("Cold")}} />
                <ResistancePanel statBoard={statBoard} statKey="DARRES" onResistanceTitleClick={() => {onResistanceTitleClick?.("Dark")}} />
                <ResistancePanel statBoard={statBoard} statKey="FORRES" onResistanceTitleClick={() => {onResistanceTitleClick?.("Force")}} />
                <ResistancePanel statBoard={statBoard} statKey="HEARES" onResistanceTitleClick={() => {onResistanceTitleClick?.("Heat")}} />
                <ResistancePanel statBoard={statBoard} statKey="LIGRES" onResistanceTitleClick={() => {onResistanceTitleClick?.("Light")}} />
                <ResistancePanel statBoard={statBoard} statKey="PIERES" onResistanceTitleClick={() => {onResistanceTitleClick?.("Piercing")}} />
                <ResistancePanel statBoard={statBoard} statKey="PSIRES" onResistanceTitleClick={() => {onResistanceTitleClick?.("Psionic")}} />
                <ResistancePanel statBoard={statBoard} statKey="SLARES" onResistanceTitleClick={() => {onResistanceTitleClick?.("Slashing")}} />
                <ResistancePanel statBoard={statBoard} statKey="SHORES" onResistanceTitleClick={() => {onResistanceTitleClick?.("Shock")}} />
            </FlexRow>
        </>
    );
}
